/**
 * Namespaced, fail-safe localStorage.
 *
 * Only PUBLIC demo tokens and non-sensitive UI state belong here:
 * table session token, order public token, cart contents, split token.
 * Never store customer PII, audio, or anything a backend would call a secret.
 */
const PREFIX = 'garson.v1.';

function available(): boolean {
  try {
    const probe = `${PREFIX}__probe`;
    window.localStorage.setItem(probe, '1');
    window.localStorage.removeItem(probe);
    return true;
  } catch {
    return false;
  }
}

const ok = typeof window !== 'undefined' && available();

export function readJson<T>(key: string, fallback: T): T {
  if (!ok) return fallback;
  try {
    const raw = window.localStorage.getItem(PREFIX + key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown): void {
  if (!ok) return;
  try {
    window.localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    /* quota or private mode — the app must keep working without persistence */
  }
}

export function remove(key: string): void {
  if (!ok) return;
  try {
    window.localStorage.removeItem(PREFIX + key);
  } catch {
    /* ignore */
  }
}

/** Keys used across the app. Centralised so nothing collides. */
export const storageKeys = {
  cart: 'cart',
  sessionToken: 'session.token',
  sessionTable: 'session.table',
  orderToken: 'order.token',
  splitToken: 'split.token',
  conversation: 'assistant.conversation',
  adminEmail: 'admin.email',
  devScenario: 'dev.scenario',
} as const;
